import React,{Component} from 'react';
import Button from '@react/react-spectrum/Button';
import _ from "lodash";
import i18n from "../../i18n";
import { withTranslation } from 'react-i18next';
import {connect} from "react-redux";
import {updateToken, setLoderStatus} from "../../actions/SecurePaymentActions";
import LoggerService from "../../services/LoggerService";
import {setAdobeAnalyticsDataForEventTracking, setAdobeAnalyticsDataForErrorEventTracking} from "../../services/analytics-util";
import {enableTokenizerErrorToastInfo,showScriptErrorMessage,showCyberSourceErrorMessage,showApiErrorMessage, showNoWalletEventErrorMessage} from "../../actions/ToastActions";
import {Grid} from '@react/react-spectrum/Grid';
import Heading from '@react/react-spectrum/Heading';

class WalletApp extends Component {

    constructor(props){
        super(props);
        this.state = {
            userDetails: props.userDetailsForTokenizer,
            loadTokenizerComponents: false
        };
        this.canSubmitPaymentFormStatus = this.canSubmitPaymentFormStatus.bind(this);
        this.submitPaymentForm = this.submitPaymentForm.bind(this);
        this.setFieldError = this.setFieldError.bind(this);
        this.sendToFrame = this.sendToFrame.bind(this);
        this.handleFrameTasks = this.handleFrameTasks.bind(this);
        this.props.setLoderStatus(true);
    }

    

    componentDidMount() {
      window.addEventListener("message", this.handleFrameTasks);
      if(!this.props.eventMiniWallet || (Object.keys(this.props.eventMiniWallet).length === 0)){
        this.props.setLoderStatus(false);
        this.props.setNoWalletEventErrorMessage(true);
      }
    }
    componentWillUnmount() {
      window.removeEventListener('message', this.handleFrameTasks);
    }

    sendToFrame(data) {
      const walletIframe = document.querySelector('#iframe');
      const cwindow = walletIframe.contentWindow;
      cwindow.postMessage(data, this.props.applicationConfig.commerce_wallet_url);
    }

    logWalletIframeEvent(eventType, result, { message, flow } = {}) {
      const isFailure = result === 'Failure';
      const messageObject = {
        Functionality: 'Mini App Wallet Token',
        Source_System: 'HDX',
        Screen: 'SecurePaymentPortal',
        CustomerGuid: _.has(this.props, 'userDetails') ? this.props.userDetails.authId : '',
        countryCode: _.has(this.props, 'userDetails') ? this.props.userDetails.countryCode : '',
        Message:
          message ||
          (isFailure
            ? 'Wallet mini app iframe event reported failure'
            : 'Wallet mini app iframe event processed'),
        Flow: flow || 'Iframe PostMessage Event',
        eventType,
        Result: result,
      };
      LoggerService.saveSplunkLog(messageObject, isFailure ? 'error' : 'info');
    }

      handleTokenizerError(error){
        var errorType = _.has(error, 'data.data.x-adobe-status.status') ? error.data.data['x-adobe-status'].status : '';
        if(errorType.indexOf('TOKEN_INVALID_INPUT') > -1){
          errorType = 'TOKEN_INVALID_INPUT';
        }
        var analyticsErrorType = errorType;
        switch(errorType){
          case 'TOKEN_MISSING_INPUT' :
          case 'TOKEN_INVALID_INPUT' :      this.props.setTokenizerErrorFlag(true);
                                            this.props.setLoderStatus(false);
                                            break;
          default:                          this.props.setApiErrorMessage(true);
                                            this.props.setLoderStatus(false);
                                            break;
        }

        // Analystics Logging start
        const agentLdap = this.props.eventMiniWallet.createdby || "";
        const analysticsObj = {
          errorEvent: 'event61',
          agentLdap: agentLdap,
          customerGuid: _.has(this.props, 'userDetails') ? this.props.userDetails.authId : '',
          customerCountryCode: _.has(this.props, 'userDetails') ? this.props.userDetails.countryCode : '',
          flowType: 'SecurePaymentPortal',
          featureName: 'Mini App Wallet Token',
          subFeatureName: 'Error Wallet Mini App',
          errorReason: analyticsErrorType,
          errorSystem: 'Upstream'
        };
        setAdobeAnalyticsDataForErrorEventTracking(analysticsObj);
        // Analystics Logging end

      }
    
      initializeWallet = () =>{
        if(!this.props.eventMiniWallet){
          return null;
        }
        const {firstName,lastName,street1,city,stateCode,postalCode,phoneNumber,taxId} = this.props.eventMiniWallet.message || "";
        const payload = {
          app: 'wallet',
          type: 'System',
          subType: 'InitializeWallet',
          data: {
            "email": this.state.userDetails.email,
            "isPPRet": false,
            "isPPSuccess": false,
            "ppPayerId": "",
            "formFieldData": {
              "firstName": firstName,
              "lastName": lastName,
              "street1": street1,
              "city": city,
              "stateCode": stateCode,
              "postalCode": postalCode,
              "phoneNumber": phoneNumber,
              "taxId": taxId
            }
          }
        }
        this.sendToFrame(payload);
      }
      canSubmitPaymentFormStatus = () => {
        const payload = {
          app: 'wallet',
          type: 'System',
          subType: 'CanSubmitPaymentForm',
          data: {}
        }
        this.sendToFrame(payload);
      }
      submitPaymentForm = () => {
        const payload = {
          app: 'wallet',
          type: 'System',
          subType: 'SubmitPaymentForm',
          data: {}
        }
        this.sendToFrame(payload);
      }
      updateTokenDetails = (paymentInstrument) => {
        let tokenDetails= {"type":"TOKEN","content":"Token: " + paymentInstrument.cardToken+" | Card Type: "+paymentInstrument.cardType + " | Expiry: " +paymentInstrument.cardExpirationMonth+"/"+paymentInstrument.cardExpirationYear  + " | Card Span: " + paymentInstrument.cardSpan,"createdBy":"SecurePaymentPortal"};
        if(this.props.termsConditionAccepted){
          tokenDetails.content =  tokenDetails.content + '| termsAccepted : true';
        }

        // Analystics Logging start in case of error
        const agentLdapError = this.props.eventMiniWallet.createdby || "";
        const analysticsObjError = {
          errorEvent: 'event61',
          agentLdap: agentLdapError,
          customerGuid: _.has(this.props, 'userDetails') ? this.props.userDetails.authId : '',
          customerCountryCode: _.has(this.props, 'userDetails') ? this.props.userDetails.countryCode : '',
          flowType: 'SecurePaymentPortal',
          featureName: 'Mini App Wallet Token',
          subFeatureName: 'Error Memo Api',
          errorReason: 'MEMO_API_ERROR',
          errorSystem: 'HxBackend'
        };
        // Analystics Logging end

        this.props.updateToken(tokenDetails, analysticsObjError);
        
        // Analystics Logging start
        const {createdBy} = this.props.eventMiniWallet.message || "";
        const agentLdap = this.props.eventMiniWallet.createdby || "";
         const analysticsObj = {
          agentLdap: agentLdap,
          customerGuid: _.has(this.props, 'userDetails') ? this.props.userDetails.authId : '',
          customerEmail: '',
          customerCountryCode: _.has(this.props, 'userDetails') ? this.props.userDetails.countryCode : '',
          flowType: createdBy+"MiniWallet",
          featureName: 'WalletToken',
          subFeatureName: 'SendToken'
        };
        setAdobeAnalyticsDataForEventTracking(analysticsObj);
      }
      setFieldError = () => {
        const payload = {
          app: 'wallet',
          type: 'System',
          subType: 'SetFieldErrors',
          data: {
            errorCode: 'PAYMENT_FAILURE'
          }
        }
        this.sendToFrame(payload);
      }
      handleFrameTasks = (e) => {
        let eventData = {};
        this.props.setLoderStatus(false);
        try {
          eventData = typeof e.data == 'object' ? e.data : JSON.parse(e.data);
        } catch {
          this.logWalletIframeEvent(
            'IFRAME_POSTMESSAGE_PARSE_FAILURE',
            'Failure',
            {
              message: 'Wallet mini app iframe message could not be parsed',
              flow: 'Iframe PostMessage Parse Failure',
            },
          );
          return;
        }
        if (!eventData || typeof eventData !== 'object') {
          this.logWalletIframeEvent(
            'IFRAME_POSTMESSAGE_INVALID_PAYLOAD',
            'Failure',
            {
              message: 'Wallet mini app iframe message was not an object',
              flow: 'Iframe PostMessage Invalid Payload',
            },
          );
          return;
        }
        try {
          switch(eventData.subType){
          case 'AppLoaded': this.props.setLoderStatus(false);
                            this.setState({loadTokenizerComponents: true});
                            this.initializeWallet();
                            this.logWalletIframeEvent(eventData.subType, 'Success');
                            break;
          case 'CanSubmitPaymentForm': 
                            if(eventData.data.canSubmitPaymentForm){
                              this.submitPaymentForm();
                            }
                            else{
                              this.setFieldError();
                            }
                            this.props.setLoderStatus(false);
                            this.setState({loadTokenizerComponents: true});
                            this.logWalletIframeEvent(
                              eventData.subType,
                              eventData.data && eventData.data.canSubmitPaymentForm ? 'Success' : 'Failure',
                            );
                            break;    
          case 'SubmitPaymentForm': this.props.setLoderStatus(false);
                            this.setState({loadTokenizerComponents: true});
                            this.logWalletIframeEvent(eventData.subType, 'Success');
                            break; 
          case 'SubmitPaymentFormSuccess':
                            this.props.setLoderStatus(false);
                            this.setState({loadTokenizerComponents: true});
                            this.updateTokenDetails(eventData.data.paymentInstrument);
                            this.logWalletIframeEvent(eventData.subType, 'Success');
                            break;  
          case 'SubmitPaymentFormError':  
                            this.handleTokenizerError(eventData);
                            this.logWalletIframeEvent(eventData.subType, 'Failure');
                            break;
          case 'Error': this.props.setLoderStatus(false);
                            this.setState({loadTokenizerComponents: true});
                            this.props.setTokenizerErrorFlag(true);
                            
                            // Analystics Logging start
                            const agentLdap = this.props.eventMiniWallet.createdby || "";
                            const analysticsObj = {
                              errorEvent: 'event61',
                              agentLdap: agentLdap,
                              customerGuid: _.has(this.props, 'userDetails') ? this.props.userDetails.authId : '',
                              customerCountryCode: _.has(this.props, 'userDetails') ? this.props.userDetails.countryCode : '',
                              flowType: 'SecurePaymentPortal',
                              featureName: 'Mini App Wallet Token',
                              subFeatureName: 'Error Wallet Mini App',
                              errorReason: 'FORM_SUBMIT_OTHER_TOKEN_ERROR',
                              errorSystem: 'Upstream'
                            };
                            setAdobeAnalyticsDataForErrorEventTracking(analysticsObj);

                            // Analystics Logging end
                            this.logWalletIframeEvent(eventData.subType, 'Failure');

                            break;                                                                   
          default           : break;
          }

        }
        catch(e){
          console.error(e)
        }
      }

      renderTokenizer(){
        // if(!this.props.eventMiniWallet || (Object.keys(this.props.eventMiniWallet).length === 0)){
        //   return null;
        // }
        const {marketSegment,currencyCode,contractId, customerSegment} = this.props.eventMiniWallet.message || "";
        let iframeUrl = "?cli=SecurePaymentPortal&awf=new&apm=c";
        // if(!_.isUndefined(purchaseContext) && purchaseContext){
        //   iframeUrl += "&ds="+purchaseContext;
        // }
        iframeUrl += "&ds=PREPURCHASE";
        iframeUrl += "&sc=DIRECT";
        // iframeUrl += "&cs=TEAM";
        // if(!_.isUndefined(salesChannel) && salesChannel){
        //   iframeUrl += "&sc="+salesChannel;
        // }
        if(!_.isUndefined(marketSegment) && marketSegment){
          iframeUrl += "&ms="+marketSegment;
        }
        if(!_.isUndefined(customerSegment) && customerSegment){
          iframeUrl += "&cs="+customerSegment;
        }
        else{
          iframeUrl += "&cs=TEAM";
        }
        if(!_.isUndefined(this.state.userDetails.countryCode) && this.state.userDetails.countryCode){
          iframeUrl += "&co="+this.state.userDetails.countryCode;
          if((this.props.featureFlags.indexOf("ENABLE_CVV_FOR_COUNTRY") > -1) && this.props.applicationConfig.enable_cvv_country_list.indexOf(this.state.userDetails.countryCode) > -1){
            iframeUrl += "&cvvc="+this.state.userDetails.countryCode;
          }
          const iframe = document.getElementById('iframe');
          if(iframe && this.props.applicationConfig.iframeHeightCountryList.indexOf(this.state.userDetails.countryCode) > -1){
            iframe.style.height = '580px'; 
          }
        }
        if(!_.isUndefined(currencyCode) && currencyCode){
          iframeUrl += "&cur="+currencyCode;
        }
        else{
          if(this.props.userCurrencyCode && this.props.userCurrencyCode.length > 0){
            iframeUrl += "&cur="+this.props.userCurrencyCode[0].code;
          }
          else{
            iframeUrl += "&cur=USD";
          }
        }
        if(!_.isUndefined(this.props.localeLanguageCode) && this.props.localeLanguageCode){
          iframeUrl += "&lang="+this.props.localeLanguageCode;
        }
        if(!_.isUndefined(contractId) && contractId){
          iframeUrl += "&coid="+contractId;
        } 
        return (
            <div className="tokenizer-form-outer"> 
              <Grid variant="fixed">
                  {this.state.loadTokenizerComponents ? <Heading className="form-heading" variant="subtitle1" style={{paddingLeft: '10px'}} data-am-id="tokenizerHeading">{i18n.t('tokenizerHeaderMessage')}</Heading>: ''}
                  <div className="align-center">
                    <iframe data-testid="iframe-container" id="iframe" title="iframe" src={this.props.applicationConfig.commerce_api_mini_wallet+iframeUrl} style={{ width: '100%', border: 'none',height:'410px' }} allow="payment"/>
                  </div>
                  {this.state.loadTokenizerComponents ? <div className="align-center">
                    {/* {this.props.enableBackButton ? <Button variant="cta" onClick={this.props.previousPage} data-am-id="tokenBackBtn">{i18n.t('label.backBtn')}</Button> : ''} */}
                    <Button variant="cta" onClick={this.submitPaymentForm} data-am-id="tokenSubmitBtn">{i18n.t('label.submitBtn')}</Button>
                  </div>: ''}
                </Grid>            
            </div>
        )
      }

      render() {
            return (
              this.renderTokenizer()
            );
        }    
}

const mapStateToProps = (state)=>{
  return{
      showSuccessMsg:state.ToastReducer.showSuccessToast,
      showTokenizerErrorToast:state.ToastReducer.showTokenizerErrorToast,
      userDetails:state.AuthReducer.userInfo,
      locale:state.LocaleReducer.goUrlLocale,
      isLoaderStatus: state.SecurePaymentReducer.isLoaderStatus,
      localeLanguageCode: state.LocaleReducer.languageCode,
      termsConditionAccepted: state.UserInfoReducer.termsConditionAccepted,
      userCurrencyCode: state.UserInfoReducer.currencyCode,
      applicationConfig : state.AppReducer.applicationConfig,
      featureFlags: state.AppReducer.featureFlags
  }
};

const mapDispatchToProps = (dispatch)=>{
  return{
      updateToken:(tokenDetails,analysticsObjError)=>{dispatch(updateToken(tokenDetails, analysticsObjError))},
      setTokenizerErrorFlag:(flag)=>{dispatch(enableTokenizerErrorToastInfo(flag))},
      setLoderStatus:(flag)=>{dispatch(setLoderStatus(flag))},
      setScriptErrorFlag:(flag)=>{dispatch(showScriptErrorMessage(flag))},
      setCyberSourceErrorFlag:(flag)=>{dispatch(showCyberSourceErrorMessage(flag))},
      setApiErrorMessage:(flag)=>{dispatch(showApiErrorMessage(flag))},
      setNoWalletEventErrorMessage:(flag)=>{dispatch(showNoWalletEventErrorMessage(flag))},
  }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(WalletApp));

